import { Component, OnInit, ElementRef } from '@angular/core';
import { ACCESSIBLE_CHANNEL_TYPE, ENDPOINTS, API_BASE_URL, USER_ROLES } from '../app.config';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import axios from 'axios';
import { ToasterService } from 'angular2-toaster';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { LowerCasePipe } from '../../../node_modules/@angular/common';
import { IMyDpOptions, IMyOptions, MyDatePicker, MyDatePickerModule } from 'mydatepicker';

import { UserInfoService } from '../shared/user-info.service';
import { CompanyService } from '../company.service';
@Component({
  selector: 'einkdevices',
  templateUrl: './einkdevices.component.html',
  styleUrls: ['./einkdevices.component.css'],
  providers: [UserInfoService]
})
export class EinkdevicesComponent implements OnInit {
  toaster: ToasterService;
  constructor( route: ActivatedRoute, toaster: ToasterService, private elem: ElementRef, router: Router,
    private userInfoService : UserInfoService, companyService: CompanyService) {
    this.toaster = toaster;
    this.router = router;
    this.route = route;
    this.companyService = companyService;
  }

  router: Router;
  einkdeviceslist: einkDeviceModel[] = [];
  updateeinkdeviceslist: einkDeviceModel[] = [];
  updateinkdeviceslist = [];
  filter: string;
  favoritebuslist = [];
  einkIndex: number;
  counter: number = 0;
  selectedeinkdeviceId: number;
  updatecounter: number = 0;
  pingVisionConnectService: boolean;
  pingVisionConnectWeb: boolean;
  syncinprogress: boolean;
  @BlockUI() blockUI: NgBlockUI;
  checkAll: boolean = false;
  busid: string = "0";
  //pagination variables
  currentPage: number;
  einkdeviceslistPerPage: number;
  einkdevicesTotal: number;
  totalPages: number;
  gettingeinkdevicesListInProgress: boolean;
  public serverurl = 'http://194.33.12.28:11113';
  public weburl = 'http://194.33.12.28:8081';
  getEinkdeviceslistConfig = {
    perPage: 10,
    filtering: false,
    filteringBy: [],
    q: ''
  };
  fromDate: any= '';
  toDate: any;
  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd.mm.yyyy'
  };
  startDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd.mm.yyyy'
  };
  htmltemplatefilter: string = "";
  connectedfilter: string = "";
  busstationfilter: string = "";
  filterpartofurl: string = "";

  //for bread crumbs
  businesOwnerName : string;
  businessOwnerIdLocalStorage = localStorage.getItem('businessOwnerId');
  userRole: string;
  dropdownSettings = {};
  companyName: string;
  companyId: string;
  channelsList = [];
  route: ActivatedRoute;
  sub: any;
  companyService: CompanyService;

  ngOnInit() {
    this.sendRequestToVisionConnect();
    this.currentPage = 1;
    this.einkdeviceslistPerPage = 10;
    this.filter = '';
    this.syncinprogress = false;
    this.getFavoriteBustStations();

    this.busid = localStorage.getItem("busId");
    if (this.busid && this.busid != "") {
      this.getEinkdevicesByBusId(this.busid);
      localStorage.setItem("busId", "");
    }
    else {
      this.busid = "0";
      this.getAllEinkdevices();

    }

    this.getTimetables();
    this.sub = this.route.params.subscribe(params => {
      this.companyId = params.companyId;
      this.companyService.setCompanyId(this.companyId);
      this.getUserInfo();
    });

  }

  getEinkdevicesByBusId(busid) {
    axios
      .get(ENDPOINTS.GET_EINKDEVICE_ALL + '?page=' + this.currentPage + '&per_page=' + this.einkdeviceslistPerPage + "&bus_station_id=" + busid)
      .then(response => {

        this.initPagingVars(response);
        this.einkdeviceslist = response.data
        this.einkdeviceslist.forEach(p => {
          if (p.bus_station) {
            p.bus_station_id = p.bus_station.id;
          }
          else {
            p.bus_station_id = -1;
          }
        });
        console.log(this.einkdeviceslist);
      });


  }

  SelectAll() {

    this.einkdeviceslist.forEach(p => {
      p.is_selected = this.checkAll;
      this.updatecounter++
    });
  }

  getAllEinkdevices() {
    let partofurl = '';// + '&connected='+'&bus_station_id='+'&html_template=';
    if (this.connectedfilter && this.connectedfilter != "") {
      partofurl += '&connected=' + this.connectedfilter;
    }
    if (this.busstationfilter && this.busstationfilter != "") {

      partofurl += '&bus_station_id=' + this.busstationfilter;

    }
    if (this.htmltemplatefilter && this.htmltemplatefilter != "") {
      partofurl += '&html_template=' + this.htmltemplatefilter;
    }
    axios
      .get(ENDPOINTS.GET_EINKDEVICE_ALL + '?page=' + this.currentPage + '&per_page=' + this.einkdeviceslistPerPage + partofurl)
      .then(response => {

        this.initPagingVars(response);
        this.einkdeviceslist = response.data
        this.einkdeviceslist.forEach(p => {
          if (p.bus_station) {
            p.bus_station_id = p.bus_station.id;
          }
          else {
            p.bus_station_id = -1;
          }

        });
        console.log(this.einkdeviceslist);
      });


  }


  sendRequestToVisionConnect() {

    axios.get(API_BASE_URL + 'visionect')
      .then(response => {
        this.pingVisionConnectService = response.data.service.online;
        this.pingVisionConnectWeb = response.data.web.online;

      }, error => {
        this.pingVisionConnectService = false;
        this.pingVisionConnectWeb = false;
      })
  }

  getTimetables() {

    axios.get(API_BASE_URL + 'timetables')
      .then(response => {

        this.fromDate = response.data.valid_from;
        let splitteddate = this.fromDate.split('.');

        this.fromDate = { date: { year: splitteddate[2], month: parseInt(splitteddate[1]), day: parseInt(splitteddate[0]) }, formatted: splitteddate[0] + '.' + splitteddate[1] + '.' + splitteddate[2] };
        this.toDate = response.data.valid_to;
        splitteddate = this.toDate.split('.');
        this.toDate = { date: { year: splitteddate[2], month: parseInt(splitteddate[1]), day: parseInt(splitteddate[0]) }, formatted: splitteddate[0] + '.' + splitteddate[1] + '.' + splitteddate[2] };


        this.setStartDatePickerOptions();
        this.setEndtDatePickerOptions();
      }, error => {

      })
  }
  public getCopyOfOptions(options): IMyOptions {
    return JSON.parse(JSON.stringify(options));
  }
  public setStartDatePickerOptions()
  {
    let copy = this.getCopyOfOptions(this.startDatePickerOptions);
    copy.disableSince = {year: this.toDate.date.year,
                         month: this.toDate.date.month,
                         day: this.toDate.date.day+1};
    this.startDatePickerOptions = copy;
  }
  public setEndtDatePickerOptions()
  {
    let copy = this.getCopyOfOptions(this.myDatePickerOptions);
    copy.disableUntil = {year: this.fromDate.date.year,
                         month: this.fromDate.date.month,
                         day: this.fromDate.date.day-1};
    this.myDatePickerOptions = copy;
  }

  setTimetables(validto = false) {

    setTimeout(() => {
      axios.put(ENDPOINTS.GET_TIMETABLE,
        { valid_from: this.fromDate.formatted, valid_to: this.toDate.formatted })
        .then(response => {
          this.fromDate = response.data.valid_from;
          let splitteddate = this.fromDate.split('.');

          this.fromDate = { date: { year: splitteddate[2], month: parseInt(splitteddate[1]), day: parseInt(splitteddate[0]) }, formatted: splitteddate[0] + '.' + splitteddate[1] + '.' + splitteddate[2] };
          this.toDate = response.data.valid_to;
          splitteddate = this.toDate.split('.');
          this.toDate = { date: { year: splitteddate[2], month: parseInt(splitteddate[1]), day: parseInt(splitteddate[0]) }, formatted: splitteddate[0] + '.' + splitteddate[1] + '.' + splitteddate[2] };

          if(validto==true)
            this.setStartDatePickerOptions();
          else this.setEndtDatePickerOptions();
        }, error => {

        });
    });
  }

  searchEinkDevices(val, field) {
    //let partofurl = '';// + '&connected='+'&bus_station_id='+'&html_template=';
    if (field == 'connected') {
      if (val != "Connected") {
        this.connectedfilter = val;
        this.updateFilterPartOfUrl(field, val);
      }
      else if (val == "Connected") {
        this.resetFilterOnTitleSelection(field);
      }
    }
    if (field == 'bus_station_id') {
      if (val != "0") {
        this.busstationfilter = val;
        this.updateFilterPartOfUrl(field, val);
      }
      else if (val == "0") {
        this.resetFilterOnTitleSelection(field);
      }
    }
    if (field == 'html_template') {
      if (val != "HTML template") {
        this.htmltemplatefilter = val;
        this.updateFilterPartOfUrl(field, val);
      }
      else if (val == "HTML template") {
        this.resetFilterOnTitleSelection(field);
      }

    }
    axios
      .get(ENDPOINTS.GET_EINKDEVICE_ALL + '?page=' + this.currentPage + '&per_page=' + this.einkdeviceslistPerPage + this.filterpartofurl)
      .then(response => {
        this.initPagingVars(response);
        this.einkdeviceslist = response.data
        this.einkdeviceslist.forEach(p => {
          if (p.bus_station) {
            p.bus_station_id = p.bus_station.id;
          }
          else {
            p.bus_station_id = -1;
          }
        });

      });
  }

  resetFilterOnTitleSelection(field) {
    let parts = this.filterpartofurl.split('&');
    if (parts && parts.length > 0) {
      parts.forEach(p => {
        if (p.indexOf(field) >= 0) {
          this.filterpartofurl = this.filterpartofurl.replace('&' + p, '');
        }
      });
    }
  }

  updateFilterPartOfUrl(field, val) {
    if (field == 'connected') {
      if (this.filterpartofurl.indexOf('connected') > 0) {
        //split with & you will get 3 parts or none
        let parts = this.filterpartofurl.split('&');
        if (parts && parts.length > 0) {
          parts.forEach(p => {
            if (p.indexOf("connected") >= 0) {
              this.filterpartofurl = this.filterpartofurl.replace('&' + p, '');
              this.filterpartofurl += '&connected=' + val;
            }
          });
        }
      }
      else {
        this.filterpartofurl += '&connected=' + val;
      }
    }
    //////////////////////////////////////////////////////////
    else if (field == 'bus_station_id') {
      if (this.filterpartofurl.indexOf('bus_station_id') > 0) {
        //split with & you will get 3 parts or none
        let parts = this.filterpartofurl.split('&');
        if (parts && parts.length > 0) {
          parts.forEach(p => {
            if (p.indexOf("bus_station_id") >= 0) {
              this.filterpartofurl = this.filterpartofurl.replace('&' + p, '');
              this.filterpartofurl += '&bus_station_id=' + val;
            }
          });
        }
      }
      else {
        this.filterpartofurl += '&bus_station_id=' + val;
      }
    }
    //////////////////////////////////////////////////////////
    else if (field == 'html_template') {
      if (this.filterpartofurl.indexOf('html_template') > 0) {
        //split with & you will get 3 parts or none
        let parts = this.filterpartofurl.split('&');
        if (parts && parts.length > 0) {
          parts.forEach(p => {
            if (p.indexOf("html_template") >= 0) {
              this.filterpartofurl = this.filterpartofurl.replace('&' + p, '');
              this.filterpartofurl += '&html_template=' + val;
            }
          });
        }
      }
      else {
        this.filterpartofurl += '&html_template=' + val;
      }
    }

    //"&bus_station_id=603102&connected=true"
  }

  openAsset(url) {
    window.open(url, '_blank');
  }

  updateEinkDevice(updateEinkObj, field) {

    if (!this.NumberValidation(updateEinkObj, field)) return;
    this.updateEinkDeviceOnebyOne(updateEinkObj, field);
  }


  ManageUpdateList(updateObj) {

    if (updateObj.is_selected)
      this.updatecounter++;
    else
      this.updatecounter--;
  }


  updateAll() {
    let ids = "";

    if (this.updatecounter > 0) {
      this.einkdeviceslist.forEach(p => {
        if (p.is_selected) {
          ids += p.id + ",";
        }
      });
      axios
        .get(ENDPOINTS.GET_EINKDEVICE_UPDATEURLS + '?ids=' + ids)
        .then(response => {


          this.checkAll = false;
          this.updatecounter = 0;

          this.getAllEinkdevices();
          this.toaster.pop("success", "Devices updated successfully");
        });
    }

  }


  updateEinkDeviceOnebyOne(updateEinkObj, field) {
    if (field.indexOf("position") >= 0) {
      axios.patch(ENDPOINTS.UPDATE_EINKDEVICE.replace(':deviceId', updateEinkObj.id), { position: updateEinkObj.position })
        .then(response => {
          this.getAllEinkdevices();
        });
    }
    if (field.indexOf("name") >= 0) {
      axios.patch(ENDPOINTS.UPDATE_EINKDEVICE.replace(':deviceId', updateEinkObj.id), { name: updateEinkObj.name })
        .then(response => {
          this.getAllEinkdevices();
        });
    }
    if (field.indexOf("number_of_lines") >= 0) {
      axios.patch(ENDPOINTS.UPDATE_EINKDEVICE.replace(':deviceId', updateEinkObj.id), { number_of_lines: updateEinkObj.number_of_lines })
        .then(response => {
          this.getAllEinkdevices();
        });
    }
    if (field.indexOf("bus_station") >= 0) {
      axios.patch(ENDPOINTS.UPDATE_EINKDEVICE.replace(':deviceId', updateEinkObj.id), { bus_station_id: updateEinkObj.bus_station_id })
        .then(response => {
          this.getAllEinkdevices();
        });
    }
    if (field.indexOf("html_template") >= 0) {
      axios.patch(ENDPOINTS.UPDATE_EINKDEVICE.replace(':deviceId', updateEinkObj.id), { html_template: updateEinkObj.html_template })
        .then(response => {
          this.getAllEinkdevices();
        });
    }
  }

  async getAllBustStationsSync() {


    this.syncinprogress = true;
    this.blockUI.start('Please wait while bus lines are being updated.' + '\n\n' + ' It might take a few minutes to complete.');
    //updating ui design of wait spinner
    let elem = document.querySelector('.message');
    elem.setAttribute('style', 'width:400px;margin:0 auto;');
    axios
      .get(ENDPOINTS.GET_BUS_SYNC_ALL)
      .then(response => {
        this.getFavoriteBustStations();
        this.getAllEinkdevices();
        this.syncinprogress = false;
        this.blockUI.stop();
        this.toaster.pop("success", "Fetched successfully");
      }, error => {
        this.toaster.pop("error", "Error in sync");
      });


  }


  EinkKeyDown(e: KeyboardEvent, value) {

    if (this.counter == 0) {
      this.einkIndex = this.einkdeviceslist.indexOf(this.einkdeviceslist.find(p => p.id == value));
      this.selectedeinkdeviceId = value;
      this.counter++;
    }


    if (e.keyCode == 13 && !e.shiftKey) {
      // prevent default behavior
      e.preventDefault();
    }
  }

  NumberValidation(updateObj, field) {

    if (field == 'position') {
      if (updateObj.position < 0) {
        this.einkdeviceslist[this.einkIndex].position = 0;
        return false;
      }
    }
    else if (field == 'number_of_lines') {
      if (updateObj.number_of_lines < 0) {
        this.einkdeviceslist[this.einkIndex].number_of_lines = 0;
        return false;
      }
    }
    return true;
  }


  getFavoriteBustStations() {
    axios
      .get(ENDPOINTS.GET_BUS_ALL + '?favourite=true')
      .then(response => {
        this.initPagingVars(response);
        this.favoritebuslist = response.data
      });
  }


  initPagingVars(response) {

    this.einkdevicesTotal = parseInt(response.headers['total'], 10);
    this.einkdeviceslistPerPage = parseInt(response.headers['per-page'], 10);
    this.totalPages = Math.floor(
      this.einkdevicesTotal % this.einkdeviceslistPerPage,
    ) === 0
      ? this.einkdevicesTotal / this.einkdeviceslistPerPage
      : Math.floor(this.einkdevicesTotal / this.einkdeviceslistPerPage) + 1;
  }

  loadeinkdeviceslist(page, isDisabled) {
    if (!isDisabled && !this.gettingeinkdevicesListInProgress) {
      this.currentPage = page;
      this.getAllEinkdevices();
    }
  }
  generatePages(current) {

    if (!this.totalPages) {
      return [];
    }
    if (!current) current = 1;
    const arr = [];
    let lenght = current + 5;

    if (lenght > this.totalPages) {
      lenght = this.totalPages;
    }
    for (let i = current; i < lenght; i++) {
      arr.push(i);
    }

    return arr;
  }

  getUserInfo() {
    const _self = this;

    this.userInfoService.getInformations()
    .subscribe( info => {
      _self.businessOwnerIdLocalStorage = localStorage.getItem('businessOwnerId');
      _self.userRole   = info.userRole;
      _self.companyName = info.companyName;
      _self.businesOwnerName = info.businesOwnerName;

      if (
        _self.userRole !== USER_ROLES.COMPANY_VIEWER &&
        _self.userRole !== USER_ROLES.COMPANY_EDITOR
      ) {
        _self.getCompanyInfo();
      }
      if (_self.userRole === USER_ROLES.COMPANY_EDITOR) {
        _self.dropdownSettings['hideRemoveButton'] = true;
      }
      if (_self.userRole === USER_ROLES.COMPANY_VIEWER) {
        _self.dropdownSettings['disabled'] = true;
      }

    });

  }

  getCompanyInfo() {
    const _self = this;
    axios
      .get(ENDPOINTS.GET_COMPANIES + '/' + _self.companyId)
      .then(response => {

          _self.companyName = response.data.name;
        _self.channelsList = _self.generateChannelsList(response.data.channels);
      });
  }
  generateChannelsList(channels) {
    const channelsList = [];
    for (const item of channels) {
      channelsList.push({
        id: item.id,
        itemName: item.name,
      });
    }
    return channelsList;
  }

}

interface einkDeviceModel {
  id: number,
  uuid: any,
  name: string,
  position: number,
  connected: boolean,
  html_template: string,
  bus_lines: string[],
  number_of_lines: number,
  url: string,
  url_sent: boolean,
  created_at: any,
  updated_at: any,
  bus_station: {
    id: number,
    name: string,
    is_favourite: boolean,
    eink_devices_count: number,
    expected_eink_devices_count: number,
    bus_lines: string[],
    created_at: any,
    updated_at: any
  },
  bus_station_id: number,
  is_selected: boolean
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/einkdevices/einkdevices.component.ts